import BaseValidator from "./BaseValidator";

// For checkboxes, expects true, false or null, not string
const checkboxValidator = Object.create(BaseValidator);

checkboxValidator.isValid = function checkboxValidatorIsValid(input) {
  if (input !== true) {
    return false;
  }
  return true;
};

checkboxValidator.isValidAndOptional =
  function checkboxValidatorIsValidAndOptional(input) {
    return [false, true, null].includes(input);
  };

export default checkboxValidator.init();
